import React from 'react';
import VisualizerGlowListItem from './inputs/glow/VisualizerGlowListItem';
import VisualizerFireListItem from './inputs/fire/VisualizerFireListItem';
import VisualizerShadowListItem from './inputs/shadow/VisualizerShadowListItem';
class VisualizerEffectsEditor extends React.Component {
    render() {
        return (
            <>
                {/* Render a list item for Glow settings */}
                <VisualizerGlowListItem />

                {/* Render a list item for Fire settings */}
                <VisualizerFireListItem />

                {/* Render a list item for Shadow settings */}
                <VisualizerShadowListItem />
            </>
        );
    }
}

export default VisualizerEffectsEditor;